import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconDiscountBadge = ({ className, children, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-discount-badge"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="20 20 100 100"
    fill="none"
    className={clsxm('h-full w-full text-warning-intense', className)}
    {...props}
  >
    <g opacity="0.8">
      <path
        opacity="0.8"
        d="M110.674 78.7041C111.297 78.8375 111.912 78.4406 112.029 77.814C113.158 71.7393 112.958 65.4871 111.437 59.489C109.821 53.1179 106.758 47.2051 102.485 42.2103C98.2123 37.2155 92.8454 33.2732 86.8015 30.6898C80.7575 28.1063 74.1992 26.9514 67.6362 27.3146C61.0733 27.6779 54.6825 29.5496 48.9606 32.7842C43.2386 36.0189 38.3396 40.5294 34.6443 45.9652C30.9489 51.401 28.5568 57.6157 27.6538 64.1263C26.8037 70.2556 27.295 76.4917 29.088 82.4046C29.2729 83.0146 29.928 83.3412 30.5327 83.1398C31.1374 82.9385 31.4628 82.2854 31.2788 81.6752C29.5973 76.0992 29.1388 70.2212 29.9401 64.4434C30.7943 58.2843 33.0573 52.4052 36.5531 47.2628C40.049 42.1205 44.6835 37.8535 50.0965 34.7935C55.5095 31.7335 61.5552 29.9629 67.7638 29.6192C73.9724 29.2756 80.1766 30.3682 85.8943 32.8122C91.6119 35.2561 96.689 38.9856 100.731 43.7107C104.773 48.4358 107.671 54.0293 109.2 60.0565C110.634 65.7105 110.827 71.6033 109.771 77.3308C109.655 77.9576 110.051 78.5707 110.674 78.7041Z"
        fill="currentColor"
      />
      <path
        opacity="0.8"
        d="M33.2063 89.3999C32.6425 89.6972 32.4251 90.3962 32.7375 90.9518C36.5978 97.8172 42.2843 103.49 49.176 107.334C56.404 111.366 64.6469 113.213 72.9042 112.651C81.1615 112.088 89.0782 109.142 95.6932 104.168C102 99.4252 106.866 93.0343 109.76 85.709C109.994 85.1163 109.684 84.4532 109.085 84.235C108.486 84.0169 107.826 84.3263 107.591 84.9188C104.85 91.8243 100.256 97.8489 94.306 102.323C88.0482 107.028 80.559 109.816 72.7475 110.348C64.936 110.879 57.1381 109.132 50.3003 105.318C43.7989 101.692 38.4313 96.3452 34.78 89.8748C34.4667 89.3197 33.7701 89.1026 33.2063 89.3999Z"
        fill="currentColor"
      />
    </g>
    <g opacity="0.5">
      <path
        opacity="0.6"
        d="M94.8932 111.832C95.1553 112.273 95.7255 112.418 96.1611 112.148C102.554 108.179 107.965 102.806 111.979 96.4315C116.157 89.7949 118.703 82.2622 119.407 74.4514C120.111 66.6405 118.952 58.7741 116.027 51.4975C113.218 44.5081 108.855 38.2543 103.274 33.207C102.894 32.8631 102.307 32.9042 101.97 33.2908C101.633 33.6774 101.675 34.2631 102.055 34.6072C107.414 39.4616 111.605 45.4729 114.305 52.1899C117.12 59.1942 118.235 66.7662 117.558 74.2848C116.88 81.8033 114.43 89.0541 110.408 95.4423C106.55 101.568 101.353 106.734 95.2115 110.552C94.7762 110.823 94.631 111.392 94.8932 111.832Z"
        fill="currentColor"
      />
      <path
        opacity="0.6"
        d="M90.9133 25.9779C91.1196 25.5437 90.935 25.0238 90.4973 24.8252C79.8239 19.982 67.7697 19.0709 56.4749 22.2714C45.18 25.4719 35.3957 32.5712 28.8497 42.2936C28.5813 42.6923 28.6968 43.2319 29.1002 43.4933C29.5035 43.7547 30.0419 43.639 30.3105 43.2404C36.6268 33.8721 46.0607 27.0314 56.9494 23.946C67.8381 20.8606 79.4583 21.7354 89.7503 26.3976C90.1881 26.5959 90.7071 26.412 90.9133 25.9779Z"
        fill="currentColor"
      />
      <path
        opacity="0.6"
        d="M25.1177 51.0005C24.6751 50.8131 24.1636 51.0198 23.984 51.4656C20.4944 60.1293 19.5194 69.6085 21.1806 78.8116C22.8934 88.3004 27.3344 97.0844 33.9604 104.089C40.5864 111.094 49.1102 116.016 58.4893 118.253C67.586 120.423 77.1048 119.976 85.949 116.973C86.4041 116.818 86.6389 116.319 86.4764 115.867C86.3139 115.415 85.8157 115.18 85.3605 115.335C76.8348 118.223 67.6608 118.651 58.8931 116.56C49.8432 114.401 41.6184 109.652 35.2249 102.893C28.8314 96.1341 24.5462 87.6583 22.8935 78.5024C21.2924 69.6322 22.2292 60.4962 25.5872 52.1442C25.7665 51.6982 25.5603 51.1878 25.1177 51.0005Z"
        fill="currentColor"
      />
    </g>
    <circle cx="70" cy="70" r={35} fill="currentColor" />
    <text
      x="70"
      y="70"
      dominantBaseline="middle"
      textAnchor="middle"
      className="fill-foreground-inverted text-xl/6 font-medium"
    >
      {children}
    </text>
  </svg>
);
